module.exports = __webpack_public_path__ + "static/img/logo.e743ab73.png";